<template>
  <div class="companies_home">
    <div class="box">
      <div class="case">
        <!-- 搜索区域 -->
        <div
          style="
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            position: relative;
          "
        >
          <!-- 检索框 -->
          <div style="width: 100%; display: flex; position: relative">
            <el-input
              placeholder="请输入公司名称、法人、案由"
              v-model="input"
              class="input-with-select tit_input"
              @keyup.enter.native="newSearch"
              clearable
            >
              <el-select
                v-model="select"
                slot="prepend"
                placeholder="请选择"
                style="width: 150px"
                class="titSelect"
              >
                <el-option
                  label="公司名称"
                  value="company_name"
                  style="text-align: center"
                ></el-option>
                <el-option
                  label="法定代表人"
                  value="legal_person"
                  style="text-align: center"
                ></el-option>
                <el-option
                  label="社会信用代码"
                  value="usco"
                  style="text-align: center"
                ></el-option>
              </el-select>
            </el-input>

            <el-button
              type="warning"
              @click="newSearch"
              style="width: 80px"
              class="search_button"
              >检索</el-button
            >
          </div>
          <!-- 高检下拉框 -->
          <el-popover placement="bottom-end" trigger="click" v-model="visible">
            <el-form
              ref="form"
              :model="form"
              label-width="100px"
              style="padding: 20px 20px 0 20px !important"
            >
              <el-form-item label="法定代表人: ">
                <div
                  class="add_s"
                  v-for="(item, index) in legal_person_s"
                  :key="index"
                >
                  <el-input
                    placeholder="请输入法定代表人"
                    v-model="item.name"
                  ></el-input>
                  <el-button
                    style="margin: 0 10px"
                    type="text"
                    @click="add_s('legal_person', index)"
                    icon="el-icon-circle-plus"
                    circle
                  ></el-button>

                  <el-button
                    :disabled="legal_person_s.length <= 1"
                    style=""
                    type="text"
                    @click="del_s('legal_person', index)"
                    icon="el-icon-remove"
                    circle
                  ></el-button>
                </div>
              </el-form-item>
              <el-form-item label="经营范围:">
                <el-input
                  placeholder="请输入经营范围"
                  v-model="condition.business"
                ></el-input>
              </el-form-item>
              <el-form-item label="地区: ">
                <!-- <el-cascader
                      v-model="form.region"
                      :options="courtData"
                      clearable
                      :props="{
                        value: 'code',
                        label: 'name',
                        children: 'children',
                        checkStrictly: true,
                      }"
                      filterable
                    ></el-cascader> -->
                <el-cascader
                  class="sel"
                  style="width: calc(45% + 90px)"
                  v-model="condition.region"
                  :options="courtData"
                  clearable
                  :props="{
                    value: 'code',
                    label: 'name',
                    children: 'children',
                    multiple: true,
                    checkStrictly: true,
                  }"
                  filterable
                  popper-class="train-tree"
                >
                </el-cascader>
              </el-form-item>
              <el-form-item label="注册资本: ">
                <div style="display: flex">
                  <el-checkbox-group v-model="condition.capital">
                    <el-checkbox
                      v-for="(item, index) in capital_s"
                      :key="index"
                      :label="item.from_to"
                      >{{ item.key }}</el-checkbox
                    >
                  </el-checkbox-group>
                  <el-popover
                    placement="bottom"
                    trigger="click"
                    v-model="visible_cap"
                  >
                    <span>注册资本 :&emsp;</span>
                    <el-input
                      style="width: 100px"
                      size="small"
                      v-model="self_cap.from"
                      clearable
                      placeholder="请输入"
                    ></el-input>
                    <span>&ensp;--&ensp;</span>
                    <el-input
                      style="width: 100px"
                      size="small"
                      v-model="self_cap.to"
                      clearable
                      placeholder="请输入"
                    ></el-input
                    >&ensp;万
                    <!-- <div style="text-align: right;margin: 10px 0 0 0;">
                          <el-button type="primary"  size="mini">确定</el-button>
                        </div> -->
                    <el-button
                      style="margin: 0 0 0 30px"
                      type="text"
                      slot="reference"
                      :style="
                        self_cap.from !== '' && self_cap.to !== ''
                          ? ''
                          : 'color: #000000;'
                      "
                      >自定义 <i class="el-icon-caret-bottom"></i
                    ></el-button>
                  </el-popover>
                </div>
              </el-form-item>
              <el-form-item label="成立年限: ">
                <div style="display: flex">
                  <el-checkbox-group v-model="condition.start_date">
                    <el-checkbox
                      v-for="(item, index) in timeData"
                      :key="index"
                      :label="item.from_to_string"
                      >{{ item.key }}</el-checkbox
                    >
                  </el-checkbox-group>
                  <el-popover
                    placement="bottom"
                    trigger="click"
                    v-model="visible_time"
                  >
                    <span>成立年限 :&emsp;</span>
                    <el-date-picker
                      v-model="self_time"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      format="yyyy 年 MM 月 dd 日"
                      value-format="yyyy-MM-dd"
                      @input="handleDate"
                    >
                    </el-date-picker>
                    <el-button
                      style="margin: 0 0 0 30px"
                      :style="
                        self_time.length > 0 && self_time !== null
                          ? ''
                          : 'color: #000000;'
                      "
                      type="text"
                      slot="reference"
                      >自定义 <i class="el-icon-caret-bottom"></i
                    ></el-button>
                  </el-popover>
                </div>
              </el-form-item>
              <el-form-item label="企业状态: ">
                <el-checkbox-group v-model="condition.status">
                  <el-checkbox
                    v-for="(item, index) in status_"
                    :key="index"
                    :label="item"
                    >{{ item }}</el-checkbox
                  >
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="资本类型: ">
                <!-- <el-checkbox-group v-model="form.unit">
                      <el-checkbox
                        v-for="(item, index) in capital_types"
                        :key="index"
                        :label="item.label"
                        >{{ item.key }}</el-checkbox
                      >
                    </el-checkbox-group> -->
                <el-radio-group v-model="condition.unit">
                  <el-radio
                    v-for="(item, index) in capital_types"
                    :key="index"
                    :label="item.label"
                    >{{ item.key }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>
              <el-form-item style="text-align: right; margin: 0px">
                <el-button type="primary" size="small" @click="seniorCase"
                  >搜 索</el-button
                >
              </el-form-item>
            </el-form>
            <el-button
              slot="reference"
              type="warning"
              style="margin: 0 0 0 20px"
              >高级检索 >></el-button
            >
          </el-popover>
        </div>
        <!-- 下方 案情 -->
        <div class="btm">
          <!-- <div class="pic_img">
            <img src="../../../assets/imgs/u1129.png" alt="" />
          </div> -->
          <div class="list">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <!-- 关注企业案情 -->
              <el-tab-pane name="first">
                <span slot="label" class="company" style="font-weight: 700">
                  关注企业案情
                  <span class="question">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="关注企业案情最新动态，获取最新企业司法风险"
                      placement="top-start"
                    >
                      <el-button
                        type="text"
                        style="font-size: 16px; font-weight: 700"
                      >
                        <i class="el-icon-question" style="color: #000"></i>
                      </el-button>
                    </el-tooltip>
                  </span>
                </span>
                <div>
                  <div
                    v-if="mineData.length > 0"
                    style="display: flex; justify-content: space-between"
                  >
                    <div class="box_" style="">
                      <el-timeline v-if="mineData.length > 0">
                        <el-timeline-item
                          placement="top"
                          v-for="(item, index) in mineData"
                          :key="index"
                          :timestamp="item.createtime"
                        >
                          <!-- <el-card> -->
                          <p class="tit"  @click="detail_id(item)">
                            {{ item.com_name }}<br />
                            <span class="new_add">
                              (新增{{ item.case.length }}篇相关文书)
                            </span>
                          </p>

                          <div class="text">
                            <div class="info">
                              {{ item.case[0].Casename }}
                            </div>
                            <div
                              class="icon"
                              @click="paperworkList(index)"
                              :style="
                                index == detail_list ? 'color: #E6A23C;' : ''
                              "
                            >
                              查看案件详情
                              <i class="el-icon-arrow-right"></i>
                            </div>
                          </div>
                          <!-- </el-card> -->
                        </el-timeline-item>
                      </el-timeline>
                    </div>
                    <div
                      class="box_right"
                      v-if="mineData[detail_list].com_name"
                    >
                      <h2 @click="detail_id(mineData[detail_list])">{{ mineData[detail_list].com_name }}</h2>
                      <h3>
                        (新增
                        <span style="font-weight: 600; color: #f37c0c">
                          {{ mineData[detail_list].case.length }} </span
                        >篇相关文书)
                      </h3>
                      <div class="case_s">
                        <div
                          class="case_"
                          v-for="(item, index) in mineData[detail_list].case"
                          :key="index"
                        >
                          <div class="Pro">{{ item.TrialPro }}</div>
                          <p>
                            <span class="case_left">文书名:</span>
                            <span
                              class="case_right"
                              style="color: #b97c21; width: calc(100% - 55px)"
                              >{{ item.Casename }}</span
                            >
                          </p>
                          <p>
                            <span class="case_left">案号:</span>
                            <span class="case_right">{{ item.CaseId }}</span>
                          </p>
                          <p>
                            <span class="case_left">案由:</span>
                            <span
                              class="case_right"
                              v-for="case_reason in item.Cause_Reason"
                              :key="case_reason.name"
                              >{{ case_reason.name }}</span
                            >
                          </p>
                          <p
                            v-for="case_party in item.Party"
                            :key="case_party.name"
                          >
                            <span class="case_left"
                              >{{ case_party.type }}:</span
                            >
                            <span class="case_right">{{
                              case_party.name
                            }}</span>
                          </p>
                          <p>
                            <span class="case_left">法院:</span>
                            <span class="case_right">{{
                              item.Court.name
                            }}</span>
                          </p>
                          <div class="case_bottom">
                            <span>{{ item.RefereeDate }}</span>
                            <span>&ensp;|&ensp;</span
                            ><span>{{ item.TrialPro }}</span>
                            &emsp;&emsp;
                            <router-link
                              :to="{
                                path: `/detail/${item._id}`,
                              }"
                              target="_blank"
                            >
                              <span class="icon"
                                >详情 <i class="el-icon-arrow-right"></i></span
                            ></router-link>
                          </div>
                          <el-divider></el-divider>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="none" v-else>
                    <img
                      src="../../../assets/imgs/企业检索入口（改）/u1439.png"
                      alt=""
                    />
                    <p v-if="!loading">暂无案情动态!</p>
                    <p v-else>
                      正在查找关注企业案情... <i class="el-icon-loading"></i>
                    </p>
                  </div>
                </div>
              </el-tab-pane>
              <!-- 今日案情动态 -->
              <el-tab-pane label="今日案情动态" name="second">
                <div>
                  <div
                    v-if="todayData.length > 0"
                    style="display: flex; justify-content: space-between"
                  >
                    <div class="box_" style="">
                      <el-timeline>
                        <el-timeline-item
                          placement="top"
                          v-for="(item, index) in todayData"
                          :key="index"
                          :timestamp="item.createtime"
                        >
                          <p class="tit"   @click="detail_id(item)">
                            {{ item.com_name }}
                            <br />
                            <span class="new_add">
                              (新增{{ item.case.length }}篇相关文书)
                            </span>
                          </p>
                          <div class="text">
                            <div class="info">
                              {{ item.case[0].Casename }}
                            </div>
                            <div
                              @click="paperworkList(index)"
                              class="icon"
                              :style="
                                index == detail_list ? 'color: #E6A23C;' : ''
                              "
                            >
                              查看文书列表
                              <i class="el-icon-arrow-right"></i>
                            </div>
                          </div>
                        </el-timeline-item>
                      </el-timeline>
                    </div>
                    <div
                      class="box_right"
                      v-if="todayData[detail_list].com_name"
                    >
                      <h2  @click="detail_id(todayData[detail_list])">{{ todayData[detail_list].com_name }}</h2>
                      <h3>
                        (新增
                        <span style="font-weight: 600; color: #f37c0c">
                          {{ todayData[detail_list].case.length }} </span
                        >篇相关文书)
                      </h3>
                      <div class="case_s">
                        <div
                          class="case_"
                          v-for="(item, index) in todayData[detail_list].case"
                          :key="index"
                        >
                          <div class="Pro">{{ item.TrialPro }}</div>
                          <p>
                            <span class="case_left">文书名:</span>
                            <span
                              class="case_right"
                              style="color: #b97c21; width: calc(100% - 55px)"
                              >{{ item.Casename }}</span
                            >
                          </p>
                          <p>
                            <span class="case_left">案号:</span>
                            <span class="case_right">{{ item.CaseId }}</span>
                          </p>
                          <p>
                            <span class="case_left">案由:</span>
                            <span
                              class="case_right"
                              v-for="case_reason in item.Cause_Reason"
                              :key="case_reason.name"
                              >{{ case_reason.name }}</span
                            >
                          </p>
                          <p
                            v-for="case_party in item.Party"
                            :key="case_party.name"
                          >
                            <span class="case_left"
                              >{{ case_party.type }}:</span
                            >
                            <span class="case_right">{{
                              case_party.name
                            }}</span>
                          </p>
                          <p>
                            <span class="case_left">法院:</span>
                            <span class="case_right">{{
                              item.Court.name
                            }}</span>
                          </p>
                          <div class="case_bottom">
                            <span>{{ item.RefereeDate }}</span>
                            <span>&ensp;|&ensp;</span
                            ><span>{{ item.CaseType }}</span
                            >&emsp;&emsp;
                            <router-link
                              :to="{
                                path: `/detail/${item._id}`,
                              }"
                              target="_blank"
                            >
                              <span class="icon"
                                >详情 <i class="el-icon-arrow-right"></i></span
                            ></router-link>
                          </div>
                          <el-divider></el-divider>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="none" v-else>
                    <img
                      src="../../../assets/imgs/企业检索入口（改）/u1439.png"
                      alt=""
                    />
                    <!-- <p></p> -->
                    <p v-if="!loading">今日案情暂未更新动态!</p>
                    <p v-else>
                      正在查找今日案情动态... <i class="el-icon-loading"></i>
                    </p>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </div>
    <ComFooter></ComFooter>
  </div>
</template>

<script>
import ComFooter from "../../../components/ComFooter.vue";
export default {
  data() {
    return {
      activeName: "first",
      input: "",
      select: "company_name",
      value_sort: { field: "", type: "desc" },
      form: {
        legal_person: [],
        business: "",
        region: [],
        capital: [],
        start_date: [],
        unit: "",
        status: [],
        company_name: "", //公司名
        usco: "", //统一社会信用代码
      },
      capital_s: [],
      capital_types: [
        {
          label: "人民币",
          key: "人民币",
        },
        {
          label: "美元",
          key: "美元",
        },
        {
          label: "其他",
          key: "其他",
        },
      ],
      status_: [],
      self_time: [],
      self_capital: [],
      self_cap: {
        from: "",
        to: "",
      },
      legal_person_s: [{ name: "" }],
      companies_field: {
        company_name: "", //公司名
        usco: "", //统一社会信用代码
        legal_person: "", //法定代表人
        region: "", //地区
        business: "", //经营范围

        status: "", //经营状态 ['在营（开业）','吊销（已注销）']
        start_date: "", //成立日期
        capital: "", //注册资金
        order: JSON.stringify(this.value_sort),
        page: 1,
        size: 10,
        unit: "", //美元| 人民币| 其他
      },
      refData: [],
      timeData: [],
      capital_s: [],
      status_: [],
      courtData: [],
      // 时间线
      reverse: true,
      activities: [],
      currentPage: 1,
      pageSize: 5,
      mineData: [], //关注企业
      // 今日案情动态
      page: 1,
      todayData: [],
      condition: {
        legal_person: [],
        business: "",
        region: "",
        capital: [],
        start_date: [],
        unit: "",
        status: [],
        company_name: "", //公司名
        usco: "", //统一社会信用代码
      },
      visible_time: false,
      visible: false,
      visible_cap: false,
      detail_list: 0,
      loading: true,
    };
  },
  created() {
    this.get_com();
    this.category();
  },
  methods: {
    detail_id(row){
        console.log(row)
        if(row.id){
            this.$router.push({ path: `/companiesDetails/${row.id}`,query: {form: ''}});
        }else{
            this.$message({
          message: '该企业暂无详情信息！',
          type: 'warning'
        });
        }
    },
    handleClick(tab, event) {
      this.detail_list = 0;
    },

    paperworkList(i) {
      this.detail_list = i;
    },
    get_com() {
      this.loading = true;
      this.$http
        .get("/com_index")
        .then((res) => {
          console.log(res);
          this.activities = res.data.data;
          this.mineData = res.data.data.my_collection;
          this.todayData = res.data.data.todays_dynamic;
          //   this.detail_list = this.todayData[0];
          if (this.mineData.length <= 0) {
            this.activeName = "second";
          }
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    newSearch() {
      this.form = {
        legal_person: [],
        business: "",
        region: [],
        capital: [],
        start_date: [],
        unit: "",
        status: [],
        company_name: "", //公司名
        usco: "", //统一社会信用代码
      };
      if (this.select == "legal_person") {
        this.form.legal_person = [this.input];
      } else {
        this.form[this.select] = this.input;
      }
      if (this.input !== "") {
        this.Jump();
      } else {
        this.$message({
          message: "请输入检索条件",
          type: "warning",
        });
      }
    },
    category() {
      this.$http
        .post("/com_category", this.companies_field)
        .then((res) => {
          console.log("category--", res);

          this.refData = res.data.data.status;
          //   this.timeData = res.data.data.start_time;
          this.timeData = [];
          res.data.data.start_time.forEach((item, index) => {
            item.from_to_string = [item.from_as_string,item.to_as_string];

            // if (item.doc_count > 0) {
            this.timeData.push(item);
            // }
          });
          //   this.capital_s = res.data.data.capital;
          this.capital_s = [];
          res.data.data.capital.forEach((item, index) => {
            item.from_to = [item.from, item.to];
            // if (item.doc_count > 0) {
            this.capital_s.push(item);
            // }
          });
          this.courtData = res.data.data.region;
          //   this.courtData.forEach((item, index) => {
          //     item.code = item.code + item.name;
          //   });
          this.status_ = [];
          this.refData.forEach((item, index) => {
            
            if (item.children) {
              item.children.forEach((item_, index_) => {
                this.status_.push(item_.key);
              });
            }else{
              this.status_.push(item.key);
            }
          });
          // window.sessionStorage.setItem("parameter", JSON.stringify(parameter));
          console.log(this.timeData);
          let criteria = {
            refData: this.refData,
            timeData: this.timeData,
            capital_s: this.capital_s,
            courtData: this.courtData,
            status_: this.status_,
          };
          window.sessionStorage.setItem(
            "parameter_criteria",
            JSON.stringify(criteria)
          );
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 高检添加
    add_s(type, i) {
      this.legal_person_s.splice(i + 1, 0, { name: "" });
    },
    // 高检删除
    del_s(type, i) {
      this.legal_person_s.splice(i, 1);
    },
    handleDate(value) {
      if (value == null) {
        this.self_time = [];
      }
    },
    // 高级检索
    seniorCase() {
      console.log(this.form.region);
      //   console.log(this.legal_person_s);
      for (var i in this.form) {
        for (var j in this.condition) {
          if (i == j) {
            if (i == "region" && this.condition[i].length > 0) {
              this.condition[i].forEach((item, index) => {
                //  console.log(item);
                this.form[i].push(item[item.length - 1]);
              });
            } else {
              this.form[i] = this.condition[i];
            }
          }
        }
      }
      if (this.legal_person_s.length > 0) {
        this.legal_person_s.forEach((item, index) => {
          if (item.name !== "") {
            this.form.legal_person.push(item.name);
          }
        });
      }

      if (this.self_time !== null && this.self_time.length > 0) {
        this.form.start_date.push(this.self_time);
      }
      if (this.self_cap.from !== null && this.self_cap.to !== "") {
        this.form.capital.push([this.self_cap.from, this.self_cap.to]);
      }
      let jump = 0;
      for (var i in this.form) {
        if (this.form[i].constructor === Array) {
          if (this.form[i].length > 0) {
            jump++;
          }
        } else {
          if (this.form[i] !== "") {
            jump++;
          }
        }
      }
      //   console.log(this.form.region)
      //   return
      if (jump > 0) {
        this.Jump();
      } else {
        this.$message({
          message: "请添加检索条件",
          type: "warning",
        });
      }
    },
    Jump() {
      window.sessionStorage.setItem(
        "enterprise_search",
        JSON.stringify(this.form)
      );
      this.visible_time = false;
      this.visible = false;
      this.visible_cap = false;
      //   return;
      this.$router.push({ path: "/companies" });
    },
    // 分页
    handleCurrentChange(val) {
      this.currentPage = val;

      this.mineData = this.queryByPage();
    },
    handleCurrentChange2(val) {
      this.page = val;
      this.todayData = this.queryByPage();
    },
    // 截取数组数据实现分页效果
    // 实现分页的方法
    queryByPage() {
      if (this.activeName === "first") {
        // 起始位置 = (当前页 - 1) x 每页的大小
        const start = (this.currentPage - 1) * this.pageSize;
        // 结束位置 = 当前页 x 每页的大小
        const end = this.currentPage * this.pageSize;
        console.log("1", this.activities.my_collection.slice(start, end));
        return this.activities.my_collection.slice(start, end);
      } else {
        // 起始位置 = (当前页 - 1) x 每页的大小
        const start = (this.page - 1) * this.pageSize;
        // 结束位置 = 当前页 x 每页的大小
        const end = this.page * this.pageSize;
        return this.activities.todays_dynamic.slice(start, end);
      }
    },
  },
  components: {
    ComFooter,
  },
};
</script>

<style  lang="less" scoped>
.companies_home {
  background: rgb(245, 239, 228);
  min-width: 1280px;
  // height: calc(100vh - 250px) !important;
  .box {
    width: 100%;
    background: url("../../../assets/imgs/raphael-schaller-GkinCd2enIY-unsplash.png");
    background-size: 100% 1000px;
    margin: auto;

    .case {
      width: 80%;
      //   min-width: 1280px;
      max-width: 1280px;
      margin: auto;
      padding: 20px;
      min-height: calc(100vh - 210px);
    }
  }
}

.tit_input {
  /deep/ .el-input-group__append {
    border: none;
  }

  /deep/ .el-input-group__prepend {
    border: none;
  }

  /deep/ .el-input__inner {
    border: none;
    border-start-start-radius: 0px;
    border-end-start-radius: 0px;
    border-end-end-radius: 0px;
    border-start-end-radius: 0px;
    // background: #fef7f0;
    background: #f7f1eb;
    border-right: #b7a974 1px solid;
    border-top: #b7a974 1px solid !important;
    border-bottom: #b7a974 1px solid;
    position: relative;
    top: 0px;
    height: 43px;
  }
}

.search_button {
  border-start-start-radius: 0px;
  border-end-start-radius: 0px;
  border-end-end-radius: 4px;
  border-start-end-radius: 4px;
}

.titSelect {
  // background: #fef7f0;
  background: #f7f1eb;
  height: 43px;
  // border: none;
  border-left: #b7a974 1px solid;
  // border-top: #b7a974 1px solid !important;
  border-bottom: #b7a974 1px solid;
  border-start-start-radius: 4px;
  border-end-start-radius: 4px;
  border-end-end-radius: 0px;
  border-start-end-radius: 0px;

  /deep/ .el-input__inner {
    text-align: center;
    // border-radius: 0;
    border-start-start-radius: 4px;
    border-end-start-radius: 4px;
    border-end-end-radius: 0px;
    border-start-end-radius: 0px;
  }

  /deep/ .el-input__suffix-inner {
    // display: inline-block;
    // border: none;
    border-start-start-radius: 4px;
    border-end-start-radius: 4px;
    border-end-end-radius: 0px;
    border-start-end-radius: 0px;
    padding: 0 15px;
    // margin-top: 5px;
    position: relative;
    top: 2px;
    border-right: 1px #e8e3dd solid;

    i {
      position: relative;
      top: -2px;
    }
  }
}

.btm {
  display: flex;
  margin-top: 30px;
  width: 100%;
  //   justify-content: center;
  //   justify-content: space-between;
  .pic_img {
    width: 38px;
    height: 27px;
    margin-right: 20px;
    margin-top: 10px;

    img {
      width: 100%;
    }
  }

  .list {
    // margin: 0 0 0 200px;
    width: 100%;
    // background-color: #f7f1eb;

    .tit {
      font-size: 16px;
      font-weight: 600;
      color: #000000a5;
      margin: 0 0 15px 0;
      display: inline-block;
      line-height: 25px;
    }
    .tit:hover{
        // font-size: 14px;
        cursor: pointer;
      color: #f37c0c;
    //   font-weight: 600;
    //   letter-spacing: 1px;
    }
    .new_add {
      font-size: 14px;
      color: #f37c0c;
      font-weight: 600;
      letter-spacing: 1px;
    }
    .text {
      //   max-width: 70%;
      color: #b97c21;
      font-size: 14px;

      //   background-color: #FCC602;
      .info {
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .icon {
        width: 100%;
        text-align: right;
        // display: flex;
        // justify-content: end;
        // align-items: center;
        margin-top: 15px;
        color: #1890ff;

        &:hover {
          cursor: pointer;
          color: #e6a23c;
        }
      }
    }

    .page-bar {
      width: 100%;
      display: flex;
      justify-content: center;
    }

    // 暂无关注企业
    .none {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: end;

      p {
        font-size: 20px;
        font-weight: 600;
        color: #e6a23c;
        margin: 150px 0 25px 0;
      }
    }

    .company {
      position: relative;

      .question {
        position: absolute;
        right: -20px;
        top: -20px;
      }
    }

    /deep/ .el-tabs__nav-wrap::after {
      height: 0 !important;
    }

    /deep/ .el-tabs__active-bar {
      background-color: #fcc602;
    }

    /deep/ .el-tabs__item.is-active {
      color: #000;
    }

    /deep/ .el-tabs__item {
      color: #00000059;
      font-size: 16px;
      font-weight: 700;
    }

    /deep/ .el-timeline {
      //   margin-top: 30px;
      //   padding: 20px 0 0 20px;
    }

    /deep/ .el-timeline-item__wrapper {
      display: flex;
    }

    /deep/ .el-timeline-item__content {
      margin-left: 20px;
      //   width: 88%;
      width: calc(100% - 100px);
    }

    /deep/ .el-timeline-item__timestamp {
      font-size: 14px;
      color: #000000a5;
    }

    /deep/.el-timeline-item__node {
      background-color: #52c41a;
    }

    /deep/ .el-timeline-item__node--normal {
      left: 0;
    }

    // 分页
    /deep/ .el-pagination.is-background .btn-next,
    .el-pagination.is-background .btn-prev,
    .el-pagination.is-background .el-pager li {
      margin: 0 !important;
      background: rgba(255, 255, 255, 0.1);
    }

    /deep/.el-pagination.is-background .btn-prev {
      margin: 0 !important;
      background: rgba(255, 255, 255, 0.1);
    }

    /deep/ .el-pagination.is-background .el-pager li {
      margin: 0 !important;
      // background: #E6A23C;
      background: rgba(255, 255, 255, 0.1);
    }

    /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #e6a23c;
      height: 25px !important;
      border-radius: 4px;
      min-width: 25px;
    }

    // 时间线宽度
    /deep/ .el-timeline-item__timestamp.is-top {
      width: 80px;
    }
  }
}
/deep/ .el-icon-circle-plus {
  font-size: 28px !important;
  color: rgb(233, 191, 7);
}
/deep/ .el-icon-remove {
  font-size: 28px !important;
  color: rgb(233, 191, 7);
}
.add_s {
  width: 100%;
  display: flex;
  margin: 0 0 10px 0;
  .el-button {
    padding: 0;
    margin: 0;
  }
}
/deep/ .el-range-separator {
  width: 25px;
}
.el-tab-pane {
}
.box_::-webkit-scrollbar {
  width: 0 !important;
}
.box_ {
  width: 48%;
  padding: 20px 20px 10px 20px;
  //   background: rgba(197, 191, 170, 0.5);
  background: rgba(255, 255, 255, 0.3);
  border-radius: 10px;
  height: calc(100vh - 450px);
  max-height: 600px;
  min-height: 450px;
  overflow-y: scroll;
  overflow-x: hidden;
}
.box_right {
  width: 48%;
  padding: 20px 20px 10px 20px;
  //   background: rgba(197, 191, 170, 0.5);
  background: rgba(255, 255, 255, 0.3);
  border-radius: 10px;
    height: calc(100vh - 450px);
  max-height: 600px;
  min-height: 450px;
  h2 {
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 1px;
  }
  h2:hover{
    cursor: pointer;
    color: #f37c0c;
  }
  h3 {
    text-align: right;
    line-height: 30px;
    // color: #f37c0c;
  }
  .case_s::-webkit-scrollbar {
    width: 0 !important;
  }
  .case_s {
    height: calc(100vh - 520px);
    margin: 0 0 10px 0;

    max-height: 520px;
    min-height: 370px;
    overflow-y: scroll;
    overflow-x: hidden;
    .case_ {
      padding: 5px 0;

      .Pro {
        border-left: 3px solid #e6a23c;
        padding: 0 10px;
        margin: 0 0 10px 0;
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 1px;
      }
      p {
        line-height: 25px;
        margin: 0 0 0 18px;
        display: flex;
        span {
          display: inline-block;
        }
      }
      .case_left {
        display: inline-block;
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 1px;
        margin: 0 5px 0 0;
      }
      .case_right {
        display: inline-block;
      }
    }
  }
}
.case_bottom {
  text-align: right;
  .icon {
    color: #1890ff;
    cursor: pointer;
  }
  .icon:hover {
    color: #e6a23c;
    // cursor: pointer;
  }
}
/deep/ .el-tabs__header {
  margin: 0 0 30px;
}
/deep/ .el-divider--horizontal {
  background-color: #b97c21 !important;
  margin: 15px 0 10px 0;
}
</style>